import { useState, useCallback } from 'react';
import type { StorageAdapter } from '../../adapters/types';
import type { BuildState } from '../../packs/types';
import { Haptics } from '../ui/haptics';
import type { ColorState } from '../colors';

export interface FleetEntry {
  id: string;
  build: BuildState;
  colors: ColorState;
  savedAt: string;
}

const FLEET_KEY = 'undef-sprite.fleet';

export function useFleet(storage: StorageAdapter) {
  const [fleet, setFleet] = useState<FleetEntry[]>([]);

  const load = useCallback(async () => {
    const raw = await storage.get(FLEET_KEY);
    if (!raw) return;
    try { setFleet(JSON.parse(raw)); } catch { /* corrupt */ }
  }, [storage]);

  const save = useCallback(async (entry: Omit<FleetEntry, 'id' | 'savedAt'>) => {
    Haptics.success();
    const next: FleetEntry[] = [
      { ...entry, id: crypto.randomUUID(), savedAt: new Date().toISOString() },
      ...fleet,
    ].slice(0, 20);
    setFleet(next);
    await storage.set(FLEET_KEY, JSON.stringify(next));
  }, [fleet, storage]);

  const remove = useCallback(async (id: string) => {
    Haptics.light();
    const next = fleet.filter(e => e.id !== id);
    setFleet(next);
    await storage.set(FLEET_KEY, JSON.stringify(next));
  }, [fleet, storage]);

  return { fleet, load, save, remove };
}
